
import React from 'react';

var currentSlide = 0;
var slides = document.querySelectorAll('#slides .slide');
var circles = document.querySelectorAll('.circles .circle');
var slideInterval = setInterval(this.nextSlide, 5000);

class Home extends React.Component {


	componentDidMount() {
		circles = document.querySelectorAll('.circles .circle');
		circles[currentSlide].className = 'circle circle-select';
		slideInterval = setInterval(this.nextSlide, 5000);
	}

	nextSlide () {

		slides = document.querySelectorAll('#slides .slide');
	    circles = document.querySelectorAll('.circles .circle');

	    slides[currentSlide].className = 'slide';
	    circles[currentSlide].className = 'circle';

	    currentSlide = (currentSlide + 1) % slides.length;
	    slides[currentSlide].className = 'slide showing';
	    circles[currentSlide].className = 'circle circle-select';
	}

	render = () => {
		return (
			<div className="main page" id="page">
				<ul id="slides">
				    <li className="slide showing">
						rewardeclub
						<br />is a customer-centered
						<br />
						<span className="slide-bold"><b>platform</b></span> that ...
				    </li>
				    <li className="slide">
						... <span className="slide-bold"><b>connects</b></span>
						<br />your business consistently
						<br />
						with its customers;
				    </li>
				    <li className="slide">
						... <span className="slide-bold"><b>brings</b></span>
						<br />your customers
						<br />
						closer than ever;
				    </li>
				    <li className="slide">
						... <span className="slide-bold"><b>rewards</b></span>
						<br />your customers
						<br />
						for their loyalty;
				    </li>
				    <li className="slide">
						... <span className="slide-bold"><b>works 24 / 7</b></span>
						<br />so you continue win
						<br />your customers back.
				    </li>
				</ul>
				<div className="circles">
					<span className="circle"></span>
					<span className="circle"></span>
					<span className="circle"></span>
					<span className="circle"></span>
					<span className="circle"></span>
				</div>
			</div>
		);
	}
}

export default Home;



// WEBPACK FOOTER //
// ./src/page/Home.js